import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Skeleton } from '../ui/skeleton';

/**
 * Skeleton loader for vendor cards in the Browse page
 * Matches the structure of actual vendor cards
 */
const VendorCardSkeleton = () => {
  return (
    <Card className="overflow-hidden">
      {/* Image placeholder */}
      <Skeleton className="h-32 sm:h-28 md:h-32 w-full rounded-none" />
      
      <CardContent className="p-3">
        {/* Business name */}
        <Skeleton className="h-5 w-3/4 mb-2" />
        
        {/* Badge placeholder */}
        <Skeleton className="h-4 w-1/2 mb-2" />
        
        {/* Location */}
        <Skeleton className="h-3 w-2/3 mb-2" />
        
        {/* Categories */}
        <div className="flex gap-1 mb-2">
          <Skeleton className="h-4 w-16" />
          <Skeleton className="h-4 w-20" />
        </div>
        
        {/* Button */}
        <Skeleton className="h-8 w-full" />
      </CardContent>
    </Card>
  );
};

/**
 * Grid of skeleton cards for browse page loading state
 */
export const VendorGridSkeleton = ({ count = 8 }) => {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
      {Array.from({ length: count }).map((_, idx) => (
        <VendorCardSkeleton key={idx} />
      ))}
    </div>
  );
};

export default VendorCardSkeleton;
